<div *ngIf="displayOnly">{{ selectedLearningCampaign.name }}</div>

<mat-form-field *ngIf="!displayOnly" class="w-100">
  <mat-label>{{ placeholder }}</mat-label>
  <mat-select name="{{ name }}-inner-select"
              [ngModel]="selectedLearningCampaignId"
              (ngModelChange)="onInnerChange($event)"
              [disabled]="isDisabled"
              [required]="required">
    <mat-option *ngFor="let campaign of learningCampaigns" [value]="campaign.id">
      {{ campaign.name }}
    </mat-option>
  </mat-select>
</mat-form-field>